/**
 * @generated SignedSource<<33c6eedc75e29e7e1b4c9f554fe760c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserRegisterWithTokenTypeInputEnum = "ACCOUNT_LINK" | "INVITATION" | "%future added value";
export type UserRegisterWithTokenInput = {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  timeZone?: string | null;
  token: string;
  type: UserRegisterWithTokenTypeInputEnum;
};
export type authRegisterUserWithTokenMutation$variables = {
  input: UserRegisterWithTokenInput;
};
export type authRegisterUserWithTokenMutation$data = {
  readonly registerUserWithToken: {
    readonly accessToken: string;
  } | null;
};
export type authRegisterUserWithTokenMutation = {
  response: authRegisterUserWithTokenMutation$data;
  variables: authRegisterUserWithTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LoginResponse",
    "kind": "LinkedField",
    "name": "registerUserWithToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authRegisterUserWithTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authRegisterUserWithTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "94a0576b1cbc0903bd7cecea1f3f6f20",
    "id": null,
    "metadata": {},
    "name": "authRegisterUserWithTokenMutation",
    "operationKind": "mutation",
    "text": "mutation authRegisterUserWithTokenMutation(\n  $input: UserRegisterWithTokenInput!\n) {\n  registerUserWithToken(input: $input) {\n    accessToken\n  }\n}\n"
  }
};
})();

(node as any).hash = "f03833b14bb5087c365ed67ea81d8d9c";

export default node;
